import * as React from "react";

declare const window: any;

interface ImageViewerProps extends React.Attributes {
    url?: string;
    dataCy?: string;
}

interface ImageViewerState {
    canOpen: boolean;
    imageViewerKey: string;
}

export class ImageViewer extends React.Component<
    ImageViewerProps,
    ImageViewerState
> {
    constructor(props) {
        super(props);

        const imageViewerKey = `openseadragon-${new Date().getMilliseconds()}`;

        this.state = {
            canOpen: true,
            imageViewerKey,
        };
    }

    componentDidMount() {
        if (window.OpenSeadragon === undefined) {
            this.setState({ canOpen: false });
            return;
        }
        this.openImage();
    }

    componentDidUpdate(prevProps: ImageViewerProps) {
        const { canOpen } = this.state;

        if (this.props.url !== prevProps.url && canOpen) {
            this.openImage();
        }
    }

    openImage = () => {
        const { imageViewerKey } = this.state;

        window.OpenSeadragon({
            id: `${imageViewerKey}`,
            prefixUrl:
                "https://relode2prodimages.blob.core.windows.net/public/js/openseadragon/2.4.0/images/",
            tileSources: {
                type: "image",
                url: this.props.url,
            },
            // Initial rotation angle
            degrees: 0,
            // Show rotation buttons
            showRotationControl: true,
            // Enable touch rotation on tactile devices
            gestureSettingsTouch: {
                pinchRotate: true,
            },
            maxZoomPixelRatio: 100,
        });
    };
    render() {
        const { url, dataCy } = this.props;

        const { canOpen, imageViewerKey } = this.state;

        if (!url) return null;

        return (
            <div style={{ width: "100%", height: "100%" }} data-cy={dataCy}>
                {canOpen ? (
                    <div
                        key={url}
                        id={imageViewerKey}
                        style={{ width: "100%", height: "100%" }}
                    />
                ) : (
                    <div>unable to open image viewer</div>
                )}
            </div>
        );
    }
}
